import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DisplayedStatusValuesEnum } from '../../utils';

@Pipe({
  name: 'DisplayFulfillmentOrderStatus',
  standalone: false,
})
export class DisplayFulfillmentOrderStatusPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: DisplayedStatusValuesEnum): string {
    return this.translateService.instant(value);
  }
}
